import { Seccion } from "@/components/solicitudes/comite/IntegranteExpediente";
import { DocBotones } from "@/components/solicitudes/comite/DocBotones";

function resultado(c) {
  if (c.modo === "Manual") return "Reporte del portal (PDF)";
  if (c.no_hit) return "Sin historial (no hit)";
  return [c.score != null ? `Score ${c.score}` : "", c.resultado].filter(Boolean).join(" · ") || "—";
}

/** Consulta SIC (buró): autorización vigente y consultas registradas. */
export function ConsultaSic({ f }) {
  const a = f.sic?.autorizacion || {};
  const consultas = f.sic?.consultas || [];
  return (
    <Seccion titulo="Consulta SIC (buró)" testid={`comite-ficha-sic-${f.cliente_id}`}>
      <div className="flex flex-wrap items-center gap-2 rounded border border-slate-200 bg-white px-2 py-1 text-[12px]"
        data-testid={`comite-sic-autorizacion-${f.cliente_id}`}>
        {a.vigente ? (
          <>
            <span className="text-slate-700">Autorización vigente hasta <b>{a.vigencia || "—"}</b> · {a.medio || "—"} · {a.fecha}</span>
            {a.documento_id && <DocBotones docId={a.documento_id} nombre="Autorizacion SIC" testid={`comite-sic-carta-${f.cliente_id}`} />}
          </>
        ) : (
          <span className="text-amber-700">Sin autorización SIC vigente{a.ultima_vigencia ? ` (venció ${a.ultima_vigencia})` : ""}.</span>
        )}
      </div>
      <ul className="mt-1.5 space-y-1 text-[12px]">
        {consultas.length === 0 && <li className="text-slate-500" data-testid={`comite-sic-sin-consultas-${f.cliente_id}`}>Sin consultas SIC registradas.</li>}
        {consultas.map((c) => (
          <li key={c.folio} className="flex flex-wrap items-center gap-2 rounded border border-slate-200 bg-white px-2 py-1"
            data-testid={`comite-sic-consulta-${c.folio}`}>
            <span className="text-slate-700">{c.sociedad} · {c.fecha} · {resultado(c)}</span>
            <span className="text-[11px] text-slate-400">{c.folio}</span>
            {c.documento_id && <DocBotones docId={c.documento_id} nombre={`Reporte ${c.folio}`} testid={`comite-sic-reporte-${c.folio}`} />}
          </li>
        ))}
      </ul>
    </Seccion>
  );
}
